import clsx from 'clsx'
import { FC } from 'react'

interface Props {
  bg: string
  text: string
  size?: 'small' | 'medium' | 'large'
  width?: string
  height?: string
  roundedSize?: string
}

export const ProfilePlaceholder: FC<Props> = ({
  bg = 'bg-green-500',
  text,
  size,
  width,
  height,
  roundedSize = 'rounded-full'
}) => {
  let dimensions = 'w-10 h-10'
  let fontSize = 'text-base font-bold'

  switch (size) {
    case 'large':
      dimensions = (width ?? 'w-12') + ' ' + (height ?? 'h-12')
      fontSize = 'text-6xl'
      break
    case 'medium':
      dimensions = 'w-12 h-12'
      fontSize = 'text-2xl font-normal'
      break
    case 'small':
      dimensions = 'w-8 h-8'
      fontSize = 'text-base'
      break
    default:
      dimensions = (width ?? 'w-12') + ' ' + (height ?? 'h-12')
      fontSize = 'text-base'
  }

  return (
    <div
      className={clsx(
        'flex items-center justify-center overflow-hidden flex-none',
        bg,
        dimensions,
        roundedSize
      )}>
      <div
        className={clsx(
          'w-full flex justify-center items-center text-white',
          fontSize
        )}>
        {text}
      </div>
    </div>
  )
}
